import { render } from "./CancellationIncentive.vue?vue&type=template&id=8680b648&scoped=true"
import script from "./CancellationIncentive.vue?vue&type=script&lang=js"
export * from "./CancellationIncentive.vue?vue&type=script&lang=js"

import "./CancellationIncentive.vue?vue&type=style&index=0&id=8680b648&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8680b648"]])

export default __exports__